import { Signal, TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  crudActions,
  DatasetTableConfig,
  formattedColumn,
  TableConfigBuilder,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { ShelfsModel } from '@models/shelfs.model';
import { Dictionary } from '@ngrx/entity/src';
import { EdgeCamera } from 'src/app/cameras/camera.model';

export type ShelfCellContext = CellTemplateContext<ShelfsModel.ShelfDocument>;

export interface CreateShelfsTableConfigDependencies {
  nameCellTemplate: TemplateRef<ShelfCellContext>;
  tagsCellTemplate: TemplateRef<ShelfCellContext>;
  camerasLookup: Signal<Dictionary<EdgeCamera.CameraItem>>;
}

export function createShelfsTableConfig(
  dependencies: CreateShelfsTableConfigDependencies,
): DatasetTableConfig<ShelfsModel.ShelfDocument> {
  const builder = new ColumnBuilder<ShelfsModel.ShelfDocument>();

  return new TableConfigBuilder<ShelfsModel.ShelfDocument>()
    .columns([
      builder
        .column('name')
        .label('SHELFS.TABLE.NAME')
        .width('minmax(200px, 1fr)')
        .cellTemplate(dependencies.nameCellTemplate)
        .mobileVisible()
        .build(),

      formattedColumn<ShelfsModel.ShelfDocument>(
        'cameraId',
        'SHELFS.TABLE.CAMERA',
        (value, row) => dependencies.camerasLookup()[row.cameraId]?.edgeOnly?.name || '',
        {
          width: 'minmax(100px, 1fr)',
          mobileVisible: true,
          cardIcon: 'ui-icon-camera',
        },
      ),

      builder
        .column('tags')
        .label('SHELFS.TABLE.TAGS')
        .width('minmax(100px, 0.8fr)')
        .cellTemplate(dependencies.tagsCellTemplate)
        .alignCenter()
        .cardIcon('ui-icon-tag')
        .build(),
    ])
    .actions(crudActions<ShelfsModel.ShelfDocument>())
    .trackBy('id')
    .build();
}
